export default "__VITE_ASSET__2c1c9c18__"